import { cn } from "@src/shared/lib/utils";

import { getStepPanelId } from "./Wizard.ids";
import type { WizardPanelProps } from "./Wizard.types";
import { useWizardContext } from "./WizardContext";

export const WizardPanel = ({
  value,
  forceMount = false,
  className,
  children,
  ...props
}: WizardPanelProps) => {
  const wizard = useWizardContext("WizardPanel");
  const { activeStep } = wizard;
  const isActive = activeStep.value === value;

  if (!isActive && !forceMount) {
    return null;
  }

  return (
    <div
      className={cn("flex w-full flex-col items-center", className)}
      hidden={!isActive}
      id={getStepPanelId(value)}
      role="tabpanel"
      tabIndex={0}
      {...props}
    >
      {children({
        activeStep: wizard.activeStep,
        activeStepIndex: wizard.activeStepIndex,
        totalSteps: wizard.totalSteps,
        isFirstStep: wizard.isFirstStep,
        isLastStep: wizard.isLastStep,
        onNext: wizard.goNext,
        onBack: wizard.goBack,
        onSkip: wizard.skip,
        onGoToStep: wizard.goToStep,
      })}
    </div>
  );
};
